module.exports = __webpack_public_path__ + "img/moller.259c4925.png";